export const faqSections = [
  {
    id: "packages",
    title: "Packages",
    questions: [
      {
        id: "packages-1",
        question: "How do I start accepting member payments?",
        answer:
          "Email support@chant.fan to request a Stripe Connect account. This process links your group's account directly, allowing you to receive payments directly and manage chargebacks and refunds.",
      },
      {
        id: "packages-2",
        question: "How do I sell member packages?",
        answer:
          "To create a member package, navigate to the Members section, select Packages, then 'Add Package'. Note that packages are sold via a web page (not via the app). After setup you will be provided the URL.\n\nSet the package as 'Active' if you are ready for it to be live on your registration web page.\n\nSet the Season, Package Name, and Expiration Date, which determines the duration of the membership. As the expiration date is reached members will be forced to renew to maintain group access.",
      },
      {
        id: "packages-3",
        question:
          "Can I sell packages for individual members? Couples? Families?",
        answer:
          "Yes. You can sell more than one package offering pricing options for members, couples and families. Set the price field:\n\nPer Member: One price for all members. No discounts for couples/families. No children added separately.\n\nPer Adult: Allows a separate price for children. Child package does not allow Chant access. Only child's name is collected. A member number is assigned. Details are stored with parent account.\n\nPer Couple: Provide a couples discount and separate price for children.\n\nPer Family: One price for the entire family. Member prompted to select '# of children' at no additional cost.",
      },
      {
        id: "packages-4",
        question: "Can I offer auto-renewal as an option?",
        answer:
          "Yes. When creating a package select 'Offer auto-renewal?'. Members will be prompted at checkout with the option to subscribe. Auto-renewals are processed annually on the member's purchase date if purchased before your package expiration date. If the member subscribed during the season they will be renewed at the beginning of next season as your new package is set to begin.\n\nIMPORTANT: You will reuse the same package season to season if auto-renewal is offered. This keeps all members on the same package and prevents you from having to maintain multiple packages. Please connect with Chant (support@chant.fan) to understand auto-renewals.",
      },
      {
        id: "packages-5",
        question:
          "Can I offer merchandise with a member package and manage fulfillment?",
        answer:
          "Yes. First, create the merchandise in Store/Merchandise and select 'Registration' making the item available to be linked to the member package.\n\nNext, return to the member package and select 'Include Merchandise' setting if the package offers one merchandise item per member (includes children), per adult, per couple or per family.\n\nYou will then select the merchandise item and save the package.\n\nAs members buy a package a new entry will be added to Store/Orders report allowing you to manage fulfillment.",
      },
      {
        id: "packages-6",
        question:
          "How do I set general overview and form fields to appear in our registration web page?",
        answer:
          "You are required to complete the form in Packages/Setup including a general image, intro, member benefits, stripe settings, etc.\n\nClick 'next' to select form fields then continue to select a partner for donations.",
      },
      {
        id: "packages-7",
        question:
          "Can I collect donations while a member is buying a package?",
        answer:
          "Yes. First, navigate to Content/Partners and add your group or community partner. Then, in Packages/Setup you have the option to select this partner to appear as an option during checkout.",
      },
      {
        id: "packages-8",
        question:
          "What if an existing member (authenticated in the app) buys a membership using the wrong email address?",
        answer:
          "If the member used auto-renewal, email support@chant.fan providing details. We will run a script to fix the subscription adding the correct email.\n\nIf auto-renewal was not used you can simply edit the member profile and manually add the new package to ensure they have access for the season.",
      },
      {
        id: "packages-9",
        question:
          "Does Chant allow me to onboard non-members with restricted access?",
        answer:
          "Yes. In Members/Onboard, set 'Option #4' to 'non-member' creating a registration link and QR code you can share via social and at events. Chant refers to non-members as 'Fans'.\n\nNext, click Fan Permissions to establish what a non-member is able to do. Some items are set one time though most are set each time you create new content (per giveaway, per event, per ticket, etc). Those forms will each have a 'Show Fan' checkbox you can select if you want non-members to have access.\n\nNote: In Packages/Setup you MUST check 'Require member package' to LOCK the group. Locking the group requires a member package for full access and limits non-members to restricted access.",
      },
    ],
  },
];
